if (window.location.href.indexOf('userProgress=') > -1) {
    window.history.replaceState({}, document.title, window.location.href.replace('userProgress=True', '').replace('userProgress=true', ''));
}
